// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Column_wrapper__yQ7zt","value":"Column_value__Ds9gG"};